var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-icontable';
                    var viewUrl = 'gfx/sprite.svg#view-icon-icontable';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 13 12',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };